
import React, {useContext} from 'react'
import AuthContext from '../../store/Auth/AuthContext';
import {Route ,Redirect} from 'react-router-dom'
function PrivateRoute({ component: Component, ...rest }) {

    const {isAuth} = useContext(AuthContext);
    // console.log("user is ", isAuth)
    return (
        <Route {...rest} render={(props) => isAuth ? <Component {...props}></Component> :
            (<Redirect to='/login' />)}
        ></Route>
    )
}

export default PrivateRoute
